/**
 * localStorage-обёртка для текущей сессии (dev-stub auth).
 *
 * После успешного `POST /api/user/v1/auth/login` сохраняем сюда полный
 * `CurrentUser` (включая `sid` и `organizationId`). Axios-интерсепторы
 * (см. `@api/meerec/client`) читают `sid` отсюда и шлют `X-Tests-User-Sid`.
 *
 * В будущем (когда появится gatekeeper-cookie) этот модуль можно удалить —
 * AuthProvider будет полагаться только на `GET /auth/me` + httpOnly cookie.
 */
import type {CurrentUser} from '../types';

const STORAGE_KEY = 'colver:auth';

/** Прочитать сохранённого юзера. Возвращает `null` если ключа нет или JSON битый. */
export const readStoredUser = (): CurrentUser | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as CurrentUser;
  } catch {
    return null;
  }
};

/** Сохранить юзера после login. */
export const writeStoredUser = (user: CurrentUser): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
};

/** Стереть сессию. */
export const clearStoredUser = (): void => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(STORAGE_KEY);
};

/** Удобный шорткат — только sid (для axios-перехватчика). */
export const readStoredSid = (): string | null => readStoredUser()?.sid ?? null;
